<!-- @Version: 1.0.0 --> 
<div [class]="'flex-img-'+fieldItem.attribute_1" [class.img-left]="fieldItem.attribute_5 == IMGPOS.LEFT.toString()" [class.img-right]="fieldItem.attribute_5 == IMGPOS.RIGHT.toString()" [class.img-center]="!(fieldItem.attribute_3 && fieldItem.attribute_3 !='')">
   @if (!(fieldItem.attribute_3 && fieldItem.attribute_3 !='') && fieldItem.attribute_1 == IMGSIZE.SEVENTYCOLUMN.toString()) {
      <div data-testid="notext-placeholder" [class]="'img-size-empty-'+fieldItem.attribute_1"></div>
   }
   <div class="right" [class]="'img-size-'+fieldItem.attribute_1" [attr.data-m-max-width]="'' | maxMinFieldWidth:!!maxWidth && maxWidth !='' ? maxWidth : FIELDWIDTH.MAX : fieldItem.attribute_1 == IMGSIZE.ROW.toString() ? ROWPOSITION.column : ROWPOSITION.row" [attr.data-m-min-width]="'' | maxMinFieldWidth:!!minWidth && minWidth !='' ? minWidth : FIELDWIDTH.MIN : fieldItem.attribute_1 == IMGSIZE.ROW.toString() ? ROWPOSITION.column : ROWPOSITION.row">
      <div data-testid="image" class="set-width">
         @if (link.src && link.src != '') {
         <a target="_blank" [attr.href]="link.src" [attr.download]="link.filename">
            <img data-testid="image-with-link" [src]="fieldItem.attribute_2" [alt]="image.altText">
         </a>
         } @else {
         <img data-testid="image-without-link" [src]="fieldItem.attribute_2" [alt]="image.altText">
         }
         @if (image.imgText && image.imgText !='') {
         <div data-testid="subtitle" [innerHTML]="image.imgText" data-width-no="100%"></div>
         }
      </div>
   </div>
   @if ((fieldItem.attribute_3 && fieldItem.attribute_3 !='') || fieldItem.attribute_1 == IMGSIZE.SEVENTYCOLUMN.toString()) {
      <div data-testid="text" [innerHTML]="fieldItem.attribute_3" class="left text-center" [class]="'img-size-'+fieldItem.attribute_1"></div>
   }
</div>